<h1 mat-dialog-title=""><span translate="">Audit log</span> - {{title | translate | titlecase}}</h1>
<mat-dialog-content class="mat-body-2">
  @if (isLoadingAuditLogEntries === false) {
    <table>
      <thead>
        <tr>
          @if (isSession === false) {
            <th><span translate="">Timestamp</span></th>
            <th><span translate="">Session</span></th>
            <th><span translate="">User</span></th>
          }
          @if (isSession === true) {
            <th><span translate="">Entity</span></th>
            <th><span translate="">Id</span></th>
          }
          <th><span translate="">Field name</span></th>
          <th><span translate="">Old value</span></th>
          <th><span translate="">New value</span></th>
        </tr>
      </thead>
      <tbody>
        @for (auditLogEntry of auditLogEntries; track auditLogEntry; let i = $index) {
          <tr>
            @if (isSession === false) {
              @if (i === 0 || auditLogEntry.sessionId !== auditLogEntries[i-1].sessionId) {
                <td [attr.rowspan]="getRowSpan(auditLogEntry)">{{auditLogEntry.timestamp | date:'short'}}</td>
              }
              @if (i === 0 || auditLogEntry.sessionId !== auditLogEntries[i-1].sessionId) {
                <td [attr.rowspan]="getRowSpan(auditLogEntry)"><a class="link" (click)="openAuditSession(auditLogEntry)">{{auditLogEntry.sessionId}}</a></td>
              }
              @if (i === 0 || auditLogEntry.sessionId !== auditLogEntries[i-1].sessionId) {
                <td [attr.rowspan]="getRowSpan(auditLogEntry)">{{auditLogEntry.username}}</td>
              }
            }
            @if (isSession === true) {
              <td>{{auditLogEntry.entityShortName | translate}}</td>
              <td><a class="link" (click)="openAuditEntity(auditLogEntry)">{{auditLogEntry.entityId}}</a></td>
            }
            <td>{{auditLogEntry.fieldName | translate}}</td>
            @if (auditLogEntry.oldValue !== null) {
              <td>{{auditLogEntry.oldValue | translate}}</td>
            }
            @if (auditLogEntry.oldValue === null) {
              <td>-</td>
            }
            @if (auditLogEntry.newValue !== null) {
              <td>{{auditLogEntry.newValue | translate}}</td>
            }
            @if (auditLogEntry.newValue === null) {
              <td>-</td>
            }
          </tr>
        }
      </tbody>
    </table>
  }
  @if (isLoadingAuditLogEntries === false && auditLogEntries !== null && auditLogEntries.length === 0) {
    <p translate="">
      No audit entries found
    </p>
  }
  @if (isLoadingAuditLogEntries === true) {
    <div class="loader mt1">
      <mat-spinner diameter="32"></mat-spinner>
      <span translate="">Retrieving audit entries</span>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions class="flex justify-start content-center items-center flex-row gap-[1rem]">
  <button mat-stroked-button="" mat-dialog-close="">
    <span translate="">Close</span>
  </button>
</mat-dialog-actions>